import { useState, useEffect } from 'react';

/** Trio device sizes: full-size shelf on md+, compact three-up on phones. */
export const useTrioSizes = () => {
  const get = () =>
    typeof window !== 'undefined' && window.innerWidth < 768
      ? { center: 168, side: 126, mobile: true }
      : { center: 282, side: 218, mobile: false };
  const [sizes, setSizes] = useState(get);
  useEffect(() => {
    const onResize = () => setSizes(get());
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return sizes;
};
